// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"sr_a bhc_b bhc_bj","SubscribedPhotoblogs__link":"sr_b bhc_a bhc_r"};